import script from "./ToolbarHeading.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarHeading.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarHeading.vue?vue&type=style&index=0&id=58761fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58761fa0"]])

export default __exports__